// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_p5-8";
export var editMode = "_p5-3";
export var headerRow = "_p5-a";
export var headerTitle = "_p5-b";
export var product = "_p5-1";
export var productDetails = "_p5-5";
export var productDivider = "_p5-7";
export var productImage = "_p5-2";
export var productInfo = "_p5-4";
export var productTitle = "_p5-6";
export var strikethrough = "_p5-9";
export var upsellProductsCard = "_p5-0";